import mainService from "./authService";
const path = "user";

export function externalEmp(id) {
    return mainService
        .post("/api/user/external", {id : id})
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}



// WEBPACK FOOTER //
// ./src/services/externalEmployee.jsx